<template>
  <div class="container">
    <div class="col-md-8 col-sm-10 mx-auto">
      <div v-if="formState == 'signIn'">
        <h3>Sign in</h3>
        <div v-if="formErrors.length" id="errorList">
          <b>Please correct the following error(s):</b>
          <ul><li v-for="(error, index) in formErrors" v-bind:key="index" class="text-danger">{{ error }}</li></ul>
        </div>
        <form>
          <div class="form-group input-group">
            <div class="input-group-prepend">
              <span class="input-group-text"><font-awesome-icon icon="user" fixed-width /></span>
            </div>
            <input
              type="text"
              class="form-control"
              id="username"
              placeholder="Username"
              v-model="form.username"
            >
          </div>
          <div class="form-group input-group">
            <div class="input-group-prepend">
              <span class="input-group-text"><font-awesome-icon icon="lock" fixed-width /></span>
            </div>
            <input
              type="password"
              class="form-control"
              id="password"
              placeholder="Password"
              aria-describedby="passwordHelp"
              v-model="form.password"
            >
            <small id="passwordHelp" class="form-text text-muted">
              Reminder: passwords are 8 or more characters and include
              lower and uppercase letters, at least one number, and at least one special character.
            </small>
          </div>
          <div class="btn-toolbar">
            <div v-if="loading" class="spinner-border text-secondary" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <button type="submit" class="btn btn-primary mr-2" @click="signIn()" v-if="!loading">Log in</button>
            <!-- Social auth is a pain, maybe later https://haverchuck.github.io/docs/js/authentication#code-samples
            <button type="button" class="btn mr-2" @click="Auth.federatedSignIn({provider: 'Facebook'})" style="background-color: #4267B2; color: white;">
              <span><font-awesome-icon icon="facebook" fixed-width />   Log in with Facebook</span>
            </button>
            <button type="button" class="btn mr-2" @click="Auth.federatedSignIn({provider: 'Google'})" style="background-color: #DB4437; color: white;">
              <span><font-awesome-icon icon="google" fixed-width />   Log in with Google</span>
            </button> -->
          </div>
        </form>
        <div>
          <span><a @click="setFormState('signUp')" class="text-link">Sign up for an account</a></span>
          <span style="float: right;"><a @click="setFormState('forgotPass')" class="text-link">Forgot password?</a></span>
        </div>
      </div>
      <div v-if="formState == 'signUp'">
        <h3>Request an account</h3>
        <p>Once your email is verified, your account still has to be approved by an admin</p>
        <div v-if="formErrors.length" id="errorList">
          <b>Please correct the following error(s):</b>
          <ul><li v-for="(error, index) in formErrors" v-bind:key="index" class="text-danger">{{ error }}</li></ul>
        </div>
        <form>
          <div class="form-group input-group">
            <div class="input-group-prepend">
              <span class="input-group-text"><font-awesome-icon icon="portrait" fixed-width /></span>
            </div>
            <input
              type="text"
              class="form-control"
              id="name"
              placeholder="Full name"
              v-model="form.name"
            >
          </div>
          <div class="form-group input-group">
            <div class="input-group-prepend">
              <span class="input-group-text"><font-awesome-icon icon="envelope" fixed-width /></span>
            </div>
            <input
              type="text"
              class="form-control"
              id="email"
              placeholder="Email address"
              v-model="form.email"
            >
          </div>
          <div class="form-group input-group">
            <div class="input-group-prepend">
              <span class="input-group-text"><font-awesome-icon icon="user" fixed-width /></span>
            </div>
            <input
              type="text"
              class="form-control"
              id="username"
              placeholder="Username"
              v-model="form.username"
            >
          </div>
          <div class="form-group input-group">
            <div class="input-group-prepend">
              <span class="input-group-text"><font-awesome-icon icon="lock" fixed-width /></span>
            </div>
            <input
              type="password"
              class="form-control"
              id="password"
              placeholder="Password"
              aria-describedby="passwordHelp"
              v-model="form.password"
            >
          </div>
          <small class="form-text text-muted">
            Passwords must be 8 or more characters and include:
            <ul>
              <li>lower and uppercase letters</li>
              <li>at least one number</li>
              <li>at least one special character.</li>
            </ul>
          </small>
          <div class="form-group input-group">
            <div class="input-group-prepend">
              <span class="input-group-text"><font-awesome-icon icon="lock" fixed-width /></span>
            </div>
            <input
              type="password"
              class="form-control"
              id="confirmPassword"
              placeholder="Confirm password"
              v-model="form.confirmPassword"
            >
          </div>
          <button type="submit" class="btn btn-primary" @click="signUp()" v-if="!loading">Sign up</button>
          <div v-if="loading" class="spinner-border text-secondary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </form>
        <div>
          <span><a @click="setFormState('signIn')" class="text-link">Have an account? Sign in</a></span>
          <span style="float: right;"><a @click="setFormState('forgotPass')" class="text-link">Forgot password?</a></span>
        </div>
      </div>
      <div v-if="formState == 'signedUp'">
        <h3>User created successfully</h3>
        <p>Please check your email for a confirmation link</p>
        <p>After confirming your email, an admin has to approve your account before you can start redeeming and submitting games</p>
      </div>
      <div v-if="formState == 'forgotPass'">
        <h3>Reset your password</h3>
        <div v-if="formErrors.length" id="errorList">
          <b>Please correct the following error(s):</b>
          <ul><li v-for="(error, index) in formErrors" v-bind:key="index" class="text-danger">{{ error }}</li></ul>
        </div>
        <form>
          <div class="form-text">
            <p>Please enter your username to reset your password</p>
          </div>
          <div class="form-group input-group">
            <div class="input-group-prepend">
              <span class="input-group-text"><font-awesome-icon icon="user" fixed-width /></span>
            </div>
            <input
              type="text"
              class="form-control"
              id="username"
              placeholder="Username"
              v-model="form.username"
            >
          </div>
          <div class="btn-toolbar">
            <button type="submit" class="btn btn-primary mr-2" @click="forgotPass()">Reset password</button>
          </div>
        </form>
        <div>
          <span><a @click="setFormState('signIn')" class="text-link">Have an account? Sign in</a></span>
          <span style="float: right;"><a @click="setFormState('signUp')" class="text-link">Sign up for an account</a></span>
        </div>
      </div>
      <div v-if="formState == 'forgotPassReset'">
        <h3>Reset your password</h3>
        <div v-if="formErrors.length" id="errorList">
          <b>Please correct the following error(s):</b>
          <ul><li v-for="(error, index) in formErrors" v-bind:key="index" class="text-danger">{{ error }}</li></ul>
        </div>
        <form>
          <div class="form-text">
            <p>Please enter the code we sent to {{ forgotPassSentTo }}</p>
          </div>
          <div class="form-group input-group">
            <div class="input-group-prepend">
              <span class="input-group-text"><font-awesome-icon icon="user" fixed-width /></span>
            </div>
            <input
              type="text"
              class="form-control"
              id="username"
              placeholder="Username"
              v-model="form.username"
              readonly="readonly"
            >
          </div>
          <div class="form-group input-group">
            <div class="input-group-prepend">
              <span class="input-group-text"><font-awesome-icon icon="key" fixed-width /></span>
            </div>
            <input
              type="text"
              class="form-control"
              id="forgotPassCode"
              placeholder="Reset code"
              v-model="form.forgotPassCode"
            >
          </div>
          <div class="form-group input-group">
            <div class="input-group-prepend">
              <span class="input-group-text"><font-awesome-icon icon="lock" fixed-width /></span>
            </div>
            <input
              type="password"
              class="form-control"
              id="password"
              placeholder="Password"
              v-model="form.password"
            >
          </div>
          <div class="form-group input-group">
            <div class="input-group-prepend">
              <span class="input-group-text"><font-awesome-icon icon="lock" fixed-width /></span>
            </div>
            <input
              type="password"
              class="form-control"
              id="forgotPassCode"
              placeholder="Confirm password"
              v-model="form.confirmPassword"
            >
          </div>
          <div class="btn-toolbar">
            <button type="submit" class="btn btn-primary mr-2" @click="forgotPassReset()">Reset password</button>
          </div>
        </form>
        <div>
          <span><a @click="setFormState('signIn')" class="text-link">Have an account? Sign in</a></span>
          <span style="float: right;"><a @click="setFormState('signUp')" class="text-link">Sign up for an account</a></span>
        </div>
      </div>
      <div v-if="formState == 'resetPassSuccess'">
        <h3>Password successfully reset, please sign in</h3>
        <p>Redirecting in a few moments... If you are not redirected,</p>
        <a @click="setFormState('signIn')" class="text-link">Click here</a>
      </div>
    </div>
  </div>
</template>

<script>
import { Auth, Hub } from 'aws-amplify'
import { Validation } from '../js/Validation'

export default {
  name: 'auth',
  props: ['user'],
  data() {
    return {
      formState: 'signIn',
      loading: false,
      form: {
        name: '',
        email: '',
        username: '',
        password: '',
        confirmPassword: '',
        forgotPassCode: ''
      },
      formErrors: [],
      forgotPassSentTo: ''
    }
  },
  mounted() {
    if (this.user.signInUserSession) {
      this.$router.push('/')
    }
  },
  methods: {
    setFormState(state) {
      this.formErrors = []
      this.formState = state
    },
    async signIn() {
      this.formErrors = []

      // Validate fields
      if (!this.form.username.length) {
        this.formErrors.push('Username cannot be blank')
      }
      if (!this.form.password.length) {
        this.formErrors.push('Password cannot be blank')
      }

      // If there were no validation issues
      if (!this.formErrors.length) {
        this.loading = true
        await Auth.signIn(this.form.username, this.form.password)
        .then((signInData) => {
          // Send a message on the event bus
          Hub.dispatch(
            'auth', 
            { 
              event: 'signIn', 
              data: signInData, 
              message:''
          })
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          if (error.code == 'UserNotFoundException' || error.code == 'NotAuthorizedException') {
            // Push generic error if the username didn't exist or the password was wrong
            this.formErrors.push('Inavlid username or password')
          } else {
            this.formErrors.push(error)
          }
        })
      }
    },
    async signUp() {
      this.formErrors = []
      
      if (!this.form.name.length) {
        this.formErrors.push('Name cannot be blank')
      }

      if (!this.form.email.length) {
        this.formErrors.push('Email cannot be blank')
      } else if (!Validation.validEmail(this.form.email)) {
        this.formErrors.push('Email format is invalid')
      }

      if (!this.form.username.length) {
        this.formErrors.push('Username cannot be blank')
      }
      
      if (!this.form.password.length) {
        this.formErrors.push('Password cannot be blank')
      } else {
        if (this.form.password.length < 9) {
          this.formErrors.push('Password must be at least 8 characters')
        }
        if (!Validation.hasUpperAndLowerCase(this.form.password)) {
          this.formErrors.push('Password must contain upper and lower case characters')
        }
        if (!Validation.hasNumber(this.form.password)) {
          this.formErrors.push('Password must contain at least one number')
        }
        if (!Validation.hasSpecialCharacter(this.form.password)) {
          this.formErrors.push('Password must contain at least one special character')
        }
        if (this.form.password != this.form.confirmPassword) {
          this.formErrors.push('Passwords do not match')
        }
      }

      // If the form pass validation
      if (!this.formErrors.length) {
        this.loading = true
        const input = {
          username: this.form.username,
          password: this.form.password,
          attributes: {
            email: this.form.email,
            name: this.form.name
          }
        }

        await Auth.signUp(input)
        .then(() => {
          this.loading = false
          this.setFormState('signedUp')
        })
      } else {
        // If there were errors scroll up to the list of errors
        this.$nextTick(function(){
          window.scrollTo(0,0)
        })
      }
    },
    async forgotPass() {
      this.formErrors = []

      if (!this.form.username.length) {
        this.formErrors.push('Username cannot be blank')
      }

      if (!this.formErrors.length) {
        await Auth.forgotPassword(this.form.username)
        .then((data) => {
          this.forgotPassSentTo = data.CodeDeliveryDetails.Destination
          this.setFormState('forgotPassReset')
        })
        .catch((err) => {
          this.formErrors.push(err.name + ': ' + err.message)
        });
      }
    },
    async forgotPassReset() {
      this.formErrors = []

      if (!this.form.password.length) {
        this.formErrors.push('Password cannot be blank')
      } else {
        if (this.form.password.length < 9) {
          this.formErrors.push('Password must be at least 8 characters')
        }
        if (!Validation.hasUpperAndLowerCase(this.form.password)) {
          this.formErrors.push('Password must contain upper and lower case characters')
        }
        if (!Validation.hasNumber(this.form.password)) {
          this.formErrors.push('Password must contain at least one number')
        }
        if (!Validation.hasSpecialCharacter(this.form.password)) {
          this.formErrors.push('Password must contain at least one special character')
        }
        if (this.form.password != this.form.confirmPassword) {
          this.formErrors.push('Passwords do not match')
        }
      }

      if (!this.form.forgotPassCode.length) {
        this.formErrors.push('Password reset code cannot be blank')
      }

      if (!this.formErrors.length) {
        await Auth.forgotPasswordSubmit(this.form.username, this.form.forgotPassCode, this.form.password)
        .then(() => {
          this.setFormState('resetPassSuccess')
          this.form.password = ''
          this.form.confirmPassword = ''
          this.form.forgotPassCode = ''
          setTimeout(() => {
            this.setFormState('signIn')
          }, 3000)
        })
        .catch((err) => {
          this.formErrors.push(err.name + ': ' + err.message)
        })
      }
    }
  }
}
</script>

<style>
.text-link {
  text-decoration: underline;
  color: DimGray;
}
</style>